export default __webpack_public_path__ + "static/media/cup.7429709a.svg";